import styled from 'styled-components'
// theme
import colors from 'themes/colors'
// components
import { Typography } from 'components/UI'

export const Layout = styled.div`
  min-height: 100vh;
  display: flex;
`

export const LeftPart = styled.div`
  width: 75%;
  background: url('/images/login.jpg') no-repeat;
  background-size: cover;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  color: ${colors.white};
  font-size: 18px;

  @media (max-width: 768px) {
    display: none;
  }
`

export const RightPart = styled.div`
  background: ${colors.white100};
  width: 25%;

  @media (max-width: 1200px) {
    width: 35%;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const Title = styled(Typography)`
  && {
    color: ${colors.white100};
  }
`

export const ContentWrapper = styled.div`
  padding-left: 20px;
`
